import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Typography from "@mui/material/Typography";
import React, { Dispatch, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { APIScopeAuthorized, loginRequestAAD } from "../authConfig";
import { AccountInfo } from "@azure/msal-common";
import { AuthenticationResult, InteractionStatus } from "@azure/msal-browser";
import { SignOutButton } from "../ui-components/SignOutButton";


type result = {
  api: string;
  error: string | null;
  result: AuthenticationResult | null;
}

export function Home() {
  const { instance, inProgress } = useMsal();
  const [_tokens, set_tokens] = useState<result[]>([]);

  useEffect(() => {
    if (inProgress === InteractionStatus.None) {

      const activeAccount = instance.getActiveAccount();
      
      if (!activeAccount) {
        set_tokens(APIScopeAuthorized.map(e => ({
          api: e.name,
          error: "No active account selected. Please sign in.",
          result: null
        })));
        return;
      }

      
      APIScopeAuthorized.forEach((e) => {
        instance.acquireTokenSilent({ scopes: [e.url], account: activeAccount as AccountInfo })
          .then(res => {
            set_tokens((prev) => {
              const x = [...prev];
              x.push({ api: e.name, error: null, result: res });
              return x;
            });
          }).catch(error => {
            set_tokens((prev) => {
              const x = [...prev];
              x.push({ api: e.name, error: error.message, result: null });
              return x;
            });
          });
      });


    }
  }, [inProgress])

  useEffect(() => {
    
    console.log("useEffect", _tokens);
  }, [_tokens])


  return (
    <>
      <AuthenticatedTemplate>
      <SignOutButton />


        <h2>Current Account</h2>
        <pre style={{ width: "90%", textWrap: "wrap", wordWrap: "break-word" }}>
          {JSON.stringify(instance.getActiveAccount(), null, 2)}
     
        </pre>
        <h2>API Scope Authorized: </h2>
        {
          _tokens.map((e, i) => {
            return (
              <div key={i}>
                <h3>{e.api}</h3>
                {
                  e.error ?
                    <p>{e.error}</p> :
                    <pre style={{ width: "90%", textWrap: "wrap", wordWrap: "break-word" }}>
                      ACCESSTOKEN:<br/>{JSON.stringify(e.result?.accessToken, null, 2)}
                      <br />
                      <br />
                      ACCOUNT:<br/>
                      {JSON.stringify(e.result?.account, null, 2)}

                      </pre>
                    
                }

                <hr />
              </div>
            )
          })
        }

        {/* <pre style={{ width: "90%", textWrap: "wrap", wordWrap: "break-word" }}>
        {error ? `Error:\n${error}` : ""}
        {_token ? "Username: " + _token.account.username : ""}
        <hr></hr>
        {_token?.scopes ? "Scopes: " + JSON.stringify(_token?.scopes, null, 2) : "no scope"}
        <hr></hr>
        {_token ? "AccessToken: " + _token?.accessToken : "no token"}
        <br />        <br />
        {_token && <a href={`https://jwt.io/#token=${_token?.accessToken}`}> jwt.io - Token </a>}
        <hr></hr>
        {_token ? "IdToken: " + JSON.stringify(_token?.idToken, null, 2).replace('"', '') : "no token"}
        <br />        <br />
        {_token && <a href={`https://jwt.io/?token=${_token?.idToken}`}> jwt.io - Token </a>}
      </pre> */}



      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>

        <Typography variant="h6" align="center">Account not found <br/> try to Authenticate</Typography>
      </UnauthenticatedTemplate>

    </>
  );
}

